import { render, staticRenderFns } from "./UserChat.vue?vue&type=template&id=60c72e4e&scoped=true&"
import script from "./UserChat.vue?vue&type=script&lang=js&"
export * from "./UserChat.vue?vue&type=script&lang=js&"
import style0 from "./UserChat.vue?vue&type=style&index=0&id=60c72e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c72e4e",
  null
  
)

export default component.exports